<template>
	<div class="p-grid">
		<div class="p-col-12">
			<p class="login-text" style="font-size: xxx-large; font-weight: bold; text-align: center; margin-top: 50px;">Ready to negotiate? <br />Upload your players now!</p>
			<div class="p-grid">
				<div class="p-col-3" style="margin-top: 10px">
				</div>
				<div class="p-col-6" style="margin-top: 10px">
					<Button label="Start" class="p-button-warning" style="font-size: large; color: white; font-weight: bold;" @click="toLogin" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -80px;
	font-size: xx-large;
}

.login-text {
	margin-top: 10px;
	font-size: 22px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -40px;
		font-size: x-large;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>